import {Component, ViewChild, Input, ElementRef, Renderer2, EventEmitter} from '@angular/core';

import { TabComponentBase } from 'app/buffer-graph/models/tab-component-base';
import { SupplierSchedule } from 'app/buffer-graph/models/suppliers-schedules/supplier-schedule';
import { BufferGraphService } from 'app/buffer-graph/services/buffer-graph.service';
import { SlickGridComponent } from 'app/slick-grid/slick-grid.component';
import { ISlickGridColumn } from 'app/slick-grid/interfaces/slick-grid-column';
import { Formatters } from 'app/slick-grid/models/formatters';
import {TranslateService} from "@ngx-translate/core";
import { Moment } from 'moment';
import * as moment from 'moment';
import {BufferGraphDataExchangeService} from "../../services/buffer-graph-data-exchange.service";

@Component({
    selector: 'chart-data',
    templateUrl: './chart-data.component.html',
    styleUrls: ['../../../slick-grid/stocks-grid-style.css', '../../styles/tabs-styles.css', './chart-data.component.css']
})
export class ChartDataComponent extends TabComponentBase<SupplierSchedule, { columns: { header: string, field: string }[], mainRows: any[] }> {
    constructor(graphService: BufferGraphService, exchangeService: BufferGraphDataExchangeService,  translateService: TranslateService, renderer: Renderer2, elementRef: ElementRef){
        super(graphService, exchangeService, translateService, renderer, elementRef);

        this.dataView = new Slick.Data.DataView<any>();
        this.options = {syncColumnCellResize: true, multiColumnSort: true, editable: false};
        this.generateColumns = true;

        this.translateService.get('ChartData').subscribe(t => this.mainRowsSheetName = t);
    }


    @ViewChild('grid')
    protected gridRef: SlickGridComponent;

    @Input()
    protected isActive: boolean;

    @Input()
    private set data(chartData: any[]) {
        this.dataView.setItems(chartData);
    }

    // protected sku: string;

    // protected warehouseCode: string;

    @Input()
    protected canSend: boolean;

    //# use default function for export data
    protected getExportData = this.getExportDataByDefault;

    //# set filter on grid
    public setFilter = (val: boolean): void => {
        if (!val){
            return;
        }
        this.dataView.setFilter(o => this.gridRef.filterHelper.filter(o));
    }

    //# download excel
    private onDownloadClick = (): void => {
        const fileName = `ChartData_${this.tab.itemInfo.sku}_Wrh_${this.tab.itemInfo.warehouseCode}.xlsx`;
        this.download(data => this.graphService.downloadBufferChangeHistory(data.columns, data.mainRows, moment.locale(), this.mainRowsSheetName)
            .map(file => { return { fileContent: file, fileName }; }));
    }

    //# send excel to email
    private onSendClick = (): void => {
        this.sendToEmail(data => this.graphService.sendBufferChangeHistory(this.tab.itemInfo.sku, this.tab.itemInfo.warehouseCode, data.columns, data.mainRows, moment.locale(), this.mainRowsSheetName));
    }
}



// WEBPACK FOOTER //
// ./src/app/buffer-graph/components/chart-data.component/chart-data.component.ts